import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../Component/ui';

interface CustomerHeaderProps {
  customerName?: string;
  customerId?: string;
}

const CustomerHeader: React.FC<CustomerHeaderProps> = ({ customerName, customerId }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="customer-header">
      <Button
        className="customer-header__back"
        icon={<ArrowLeftOutlined />}
        onClick={() => history.goBack()}
      >
        {t('common.back', 'Back')}
      </Button>

      <PageHeader
        icon={<UserOutlined />}
        title={
          customerName ||
          `Customer ID: ${customerId}` ||
          t('customers.details.title', 'Customer Details')
        }
        subtitle={
          customerId
            ? `${t('customers.details.customerId', 'Customer ID')}: ${customerId}`
            : undefined
        }
      />
    </div>
  );
};

export default CustomerHeader;
